<template>
  <div class="container">
    <MnRow>
      <MnColumn :colSpan="{ sm: 12 }">
        <DashboardReportingsPending />
      </MnColumn>
      <MnColumn :colSpan="{ sm: 12 }">
        <DashboardOrganizationManagement />
      </MnColumn>
      <MnColumn :colSpan="{ sm: 12 }">
        <DashboardReportStatistics />
      </MnColumn>
    </MnRow>
  </div>
</template>
<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { onMounted } from 'vue';

// Components
import MnRow from '@/components/common/MnRow.vue';
import MnColumn from '@/components/common/MnColumn.vue';
import DashboardReportingsPending from './DashboardReportingsPending.vue';
import DashboardOrganizationManagement from './DashboardOrganizationManagement.vue';
import DashboardReportStatistics from './DashboardReportStatistics.vue';

// Composables
import { usePageHelper } from '@/composables/pageHelper';

// Stores
import { useProgramDashboardStore } from '../stores/ProgramDashboardStore';

// Constants and Utils


// ===============================
// PROPS & EMITS
// ===============================


// ===============================
// COMPOSABLES & STORES
// ===============================
const pageHelper = usePageHelper();
const store = useProgramDashboardStore();

// ===============================
// REACTIVE STATE
// ===============================


// ===============================
// CONSTANTS
// ===============================


// ===============================
// COMPUTED PROPERTIES
// ===============================


// ===============================
// METHODS
// ===============================


// ===============================
// WATCHERS
// ===============================


// ===============================
// LIFECYCLE HOOKS
// ===============================
onMounted(async () => {
  await pageHelper.fetch(() => store.fetch());
});

// ===============================
// EXPOSE
// ===============================




</script>